<template>
  <div class="capacity-overview">
    <div class="stats-container">
      <div class="heading d-flex justify-content-between">
        <img :src="getImage('meter.svg')" alt="">
        <span class="title">{{ $t('hose.capacityOverview.capacity') }}</span>
      </div>
      <div class="stats-column">
        <stats-item :label="$t('hose.capacityOverview.length')"
                    :value="preferences.length"
                    unit="mm"
        ></stats-item>
        <stats-item :label="$t('hose.capacityOverview.maxPressure')"
                    :value="maxPressure"
                    :unit="preferences.unit"
        ></stats-item>
        <stats-item :label="$t('hose.capacityOverview.burstPressure')"
                    :value="selectedHose.burst_pressure ? preferences.unit === 'psi' ? selectedHose.burst_pressure * PSI : selectedHose.burst_pressure : 0"
                    :unit="preferences.unit"
        ></stats-item>
        <stats-item :label="$t('hose.capacityOverview.bendRadius')"
                    :value="selectedHose.bend_radius ? selectedHose.bend_radius : 0"
                    unit="mm"
        ></stats-item>
        <stats-item :label="$t('hose.capacityOverview.recommendedPressureHose')"
                    :value="selectedHose.flow_pressurehose ? selectedHose.flow_pressurehose : 0"
                    unit="l/m"
        ></stats-item>
        <stats-item :label="$t('hose.capacityOverview.recommendedReturnHose')"
                    :value="selectedHose.flow_retour ? selectedHose.flow_retour : 0"
                    unit="l/m"
        ></stats-item>
        <stats-item :label="$t('hose.capacityOverview.recommendedSuctionLine')"
                    :value="selectedHose.flow_suction ? selectedHose.flow_suction : 0"
                    unit="l/m"
        ></stats-item>
      </div>
    </div>
  </div>
</template>

<script>
import StatsItem from "@/components/hose/components/StatsItem";
import {mapGetters} from "vuex";

export default {
  name: "HoseCapacityOverview",

  components: {StatsItem},

  computed: {
    ...mapGetters({
      preferences: 'build/hoses/getHosePreferences',
      build: 'build/hoses/getHoseBuild',
      PSI: 'build/hoses/getPSI'
    }),
    selectedHose() {
      return this.build.selectedHose;
    },
    maxPressure() {
      const lowestPressure = Math.min(
          this.build.selectedHose.pressure,
          this.build.couplingA?.max_pressure,
          this.build.couplingB?.max_pressure
      );

      return lowestPressure ? this.preferences.unit === 'psi' ? lowestPressure * this.PSI : lowestPressure : 0;
    }
  }
}
</script>

<style scoped lang="scss">
  .capacity-overview {
    grid-row-start: 1;
    grid-row-end: 2;
    background-color: #FAFAFA;
    color: #3C3C3B;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.06);
    padding: 20px 15px;
    font-family: neue-haas-grotesk-text, sans-serif;

    .stats-container {

      .heading {
        align-items: center;

        img {
          max-width: 21px;
          max-height: 21px;
        }
        .title {
          font-size: 14px;
          margin-right: auto;
          margin-left: 13px;
          font-family: neue-haas-grotesk-display, sans-serif;
        }
      }

      .stats-column {
        display: flex;
        flex-direction: column;
      }
    }
  }
</style>
